<template>
  <header class="culture-hero" :class="{ 'culture-hero-image': image }" :style="backgroundStyle">
    <v-container>
      <p v-if="eyebrow">{{ eyebrow }}</p>
      <h1>{{ title }}</h1>
      <div v-if="status" class="status">{{ status }}</div>
      <p class="summary">{{ summary }}</p>
      <slot></slot>
    </v-container>
  </header>
</template>
<script>export default {
  name: 'CultureHero',
  props: {
    title: { type: String, required: true }, summary: { type: String, required: true }, eyebrow: { type: String, default: '' }, status: { type: String, default: '' }, image: { type: [String, Object], default: '' },
  },
  computed: {
    backgroundStyle() {
      const source = this.$options.filters.mediaSrc(this.image);
      return source ? { backgroundImage: `linear-gradient(90deg, rgba(0,0,0,.94), rgba(0,0,0,.42)), url(${source})` } : null;
    },
  },
}; </script>
<style scoped>.culture-hero{background:radial-gradient(circle at 80% 20%,#251308 0,#090909 44%);border-bottom:1px solid #2c2c2c;padding:78px 0 70px}.culture-hero-image{background-position:center;background-size:cover}.culture-hero .container{position:relative}.culture-hero p:first-child{color:#e23232;font-family:"Oswald",sans-serif;font-size:.9rem;font-weight:900;margin:0 0 10px;text-transform:uppercase}.culture-hero h1{color:#fff;font-family:"Oswald",sans-serif;font-size:clamp(3rem,8vw,5.8rem);line-height:.98;margin:0;max-width:900px}.summary{color:#d1d1d1;font-size:clamp(1.05rem,2vw,1.3rem);line-height:1.6;margin:24px 0 0;max-width:790px}.status{background:#1b6d3a;border-radius:999px;color:#fff;display:inline-block;font-size:.72rem;font-weight:900;margin-top:18px;padding:6px 11px;text-transform:uppercase}@media(max-width:600px){.culture-hero{padding:52px 0}.culture-hero h1{font-size:3rem}}</style>
